import { request } from "./http";

export interface CommissionDay {
  date: string;
  symbol: string;
  total: string;
  fill_count: number;
}

export interface CommissionReport {
  trading_account_id: string;
  grand_total: string;
  by_day: CommissionDay[];
  by_symbol: Record<string, string>;
}

export const commissions = {
  report: (trading_account_id: string, fromTs?: string, toTs?: string) => {
    const p = new URLSearchParams({ trading_account_id });
    if (fromTs) p.set("from_ts", fromTs);
    if (toTs) p.set("to_ts", toTs);
    return request<CommissionReport>(`/api/v1/commissions?${p.toString()}`);
  },
};
